import React from "react";

export default function ThumbUpsSvgIcon() {
  return (
    <svg
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="#D1FADF"
        d="M13.5944 12.9708C13.4443 13.9465 12.6048 14.6667 11.6177 14.6667H2.66683C1.93045 14.6667 1.3335 14.0698 1.3335 13.3334V8.66671C1.3335 7.93033 1.93045 7.33337 2.66683 7.33337H4.23358C4.49704 7.33337 4.73579 7.17822 4.84279 6.93747L7.18887 1.65879C7.27682 1.4609 7.47305 1.33337 7.6896 1.33337C8.5975 1.33337 9.3335 2.06937 9.3335 2.97727V5.33337C9.3335 5.70156 9.63197 6.00004 10.0002 6.00004H12.3356C13.5614 6.00004 14.4987 7.09264 14.3124 8.30416L13.5944 12.9708Z"
      />
      <path
        stroke="#12B76A"
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M4.66683 14.6667V7.33337M1.3335 8.66671V13.3334C1.3335 14.0698 1.93045 14.6667 2.66683 14.6667H11.6177C12.6048 14.6667 13.4443 13.9465 13.5944 12.9708L14.3124 8.30416C14.4987 7.09264 13.5614 6.00004 12.3356 6.00004H10.0002C9.63197 6.00004 9.3335 5.70156 9.3335 5.33337V2.97727C9.3335 2.06937 8.5975 1.33337 7.6896 1.33337C7.47305 1.33337 7.27682 1.4609 7.18887 1.65879L4.84279 6.93747C4.73579 7.17822 4.49704 7.33337 4.23358 7.33337H2.66683C1.93045 7.33337 1.3335 7.93033 1.3335 8.66671Z"
      />
    </svg>
  );
}
